// src/api/AdminEndpoints.js
import { api } from "./client";

export const AdminAPI = {
  /**
   * Holt Logs aus Loki über dein Backend (ADMIN only)
   * Backend Endpoint: GET /api/admin/logs?service=backend&limit=200
   */
  getLogs: async ({ service = "backend", limit = 200, minutes = 60, contains = "" } = {}) => {
    const params = { service, limit, minutes };
    if (contains?.trim()) params.contains = contains.trim();
    const { data } = await api.get("/api/admin/logs", { params });
    return data;
  },

  getLogServices: async () => {
    const { data } = await api.get("/api/admin/logs/services");
    return data;
  },

  getMetricsOverview: async ({ windowMinutes = 5 } = {}) => {
    const { data } = await api.get("/api/admin/metrics/overview", {
      params: { windowMinutes },
    });
    return data;
  },
};
